import React from "react";
import { MdCancel } from "react-icons/md";
import { updateOrder } from "../../services/order.service";
import { toast } from "react-toastify";
import { showAlert } from "../../components/common/alert";

export default function CancelOrderButton({ order, bussinessUuid, theme, onSuccess, setPageLoading }) {
  const canCancel = order.orderStatus === "Ordered" ||
    order.orderStatus === "Confirmed" ||
    order.orderStatus === "Processing" ||
    order.orderStatus === "pending";

  if (!canCancel) return null;

  const handleCancelOrder = async () => {
    const preConfirm = async () => {
      try {
        setPageLoading(true);
        const res = await updateOrder(bussinessUuid, order.customerId, order.orderId, { orderStatus: "Cancelled" });
        if (res) {
          toast.success("Order cancelled successfully");
          onSuccess();
        }
      } catch (error) {
        toast.error("Failed to cancel order");
        setPageLoading(false);
      }
    };

    showAlert(
      "Are you sure you want to cancel this order?",
      preConfirm,
      "Yes, Cancel"
    );
  };

  return (
    <button
      className='flex items-center gap-2 px-4 py-2 rounded-lg font-medium transition-all duration-200 border'
      onClick={handleCancelOrder}
      style={{
        backgroundColor: '#fee2e2',
        color: '#ef4444',
        borderColor: '#fca5a5',
        borderRadius: theme?.borderRadius || '8px',
        fontFamily: theme?.fontFamily || 'Inter',
      }}
    >
      <MdCancel className='text-lg' />
      Cancel Order
    </button>
  );
}
